(() => {
  const initHero = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    const slides = [...root.querySelectorAll('.ll-hero__slide')];
    const dots = [...root.querySelectorAll('.ll-hero__dot')];
    if (slides.length < 2) return;
    root.dataset.ready = 'true';
    let active = 0;
    let timer;
    const delay = Number(root.dataset.autoplaySeconds || 6) * 1000;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), delay);
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    show(0);
    start();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-ll-hero]').forEach(initHero);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
